/**
 * Calls in reserve ships to replace losses, one per `killsPerReinforcement` kills
 * made after the loss. Ships come from the reserve in order and each can only be
 * called in once, so an empty reserve means no more reinforcements.
 */
export class ReinforcementTracker<T> {
  private readonly reserve: T[];
  private pending = 0;
  private kills = 0;

  constructor(private readonly killsPerReinforcement: number, reserve: T[]) {
    this.reserve = [...reserve];
  }

  onShipLost(): void {
    if (this.pending >= this.reserve.length) return;
    if (this.pending === 0) this.kills = 0;
    this.pending++;
  }

  /** Returns the reserve ship to warp in, if this kill earned one. */
  onKill(): T | null {
    if (!this.active()) return null;

    this.kills++;
    if (this.kills < this.killsPerReinforcement) return null;

    this.kills = 0;
    this.pending--;
    return this.reserve.shift()!;
  }

  killsUntilNext(): number | null {
    if (!this.active()) return null;
    return this.killsPerReinforcement - this.kills;
  }

  reserveRemaining(): number {
    return this.reserve.length;
  }

  private active(): boolean {
    return this.killsPerReinforcement > 0 && this.pending > 0 && this.reserve.length > 0;
  }
}
